import React from 'react';
import { Grid } from '@material-ui/core';
import PageHeader from 'pages/breakout/components/PageHeader';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { BookingUser } from 'components/BookingForm';

const BookingPage = () => {
  // Hooks
  const intl = useIntl();
  const i18n = translations.Agenda(intl).forms;
  return (
    <Grid container>
      <div style={{ width: '100%' }}>
        <PageHeader i18n={i18n.user} isBrandPage={false} />
        <div style={{ width: '90%', margin: '0 auto', maxWidth: 1063 }}>
          {/* <BookingBrand /> */}
          <BookingUser />
        </div>
      </div>
    </Grid>
  );
};
export default BookingPage;
